(function () {
  if (window.__aalisIngredientModalInit) return;
  window.__aalisIngredientModalInit = true;

  var USEDIN_CAP = 5;

  function init() {
    var modal = document.querySelector('[data-ingredient-modal]');
    if (!modal) return;

    var img = modal.querySelector('[data-ingredient-modal-image]');
    var statusEl = modal.querySelector('[data-ingredient-modal-status]');
    var nameEl = modal.querySelector('[data-ingredient-modal-name]');
    var commonEl = modal.querySelector('[data-ingredient-modal-common]');
    var tagsEl = modal.querySelector('[data-ingredient-modal-tags]');
    var elWrap = modal.querySelector('[data-ingredient-modal-el-wrap]');
    var elText = modal.querySelector('[data-ingredient-modal-el]');
    var enWrap = modal.querySelector('[data-ingredient-modal-en-wrap]');
    var enText = modal.querySelector('[data-ingredient-modal-en]');
    var avoidWrap = modal.querySelector('[data-ingredient-modal-avoid-wrap]');
    var avoidText = modal.querySelector('[data-ingredient-modal-avoid]');
    var sourceLink = modal.querySelector('[data-ingredient-modal-source]');
    var usedinWrap = modal.querySelector('[data-ingredient-modal-usedin-wrap]');
    var usedinList = modal.querySelector('[data-ingredient-modal-usedin]');
    var usedinMore = modal.querySelector('[data-ingredient-modal-usedin-more]');

    if (usedinMore) {
      usedinMore.addEventListener('click', function () {
        if (!usedinList) return;
        var hiddenPills = usedinList.querySelectorAll('[hidden]');
        hiddenPills.forEach(function (el) { el.hidden = false; });
        usedinMore.style.display = 'none';
      });
    }

    function openModalFromChip(chip) {
      var d = chip.dataset;
      if (img) {
        img.src = d.image || '';
        img.alt = d.common || d.name || '';
        img.style.display = d.image ? '' : 'none';
      }

      if (statusEl) {
        statusEl.textContent = d.status === 'avoid' ? 'ΑΠΟΦΥΓΗ' : 'ΧΡΗΣΙΜΟΠΟΙΕΙΤΑΙ';
        statusEl.setAttribute('data-status', d.status || 'use');
      }

      if (nameEl) nameEl.textContent = d.name || '';

      if (commonEl) {
        commonEl.textContent = d.common && d.common !== d.name ? d.common : '';
        commonEl.style.display = commonEl.textContent ? '' : 'none';
      }

      if (tagsEl) {
        tagsEl.textContent = d.tags || '';
        tagsEl.style.display = d.tags ? '' : 'none';
      }

      if (elText && elWrap) {
        elText.textContent = d.descEl || '';
        elWrap.style.display = d.descEl ? '' : 'none';
      }

      if (enText && enWrap) {
        enText.textContent = d.descEn || '';
        enWrap.style.display = d.descEn ? '' : 'none';
      }

      if (avoidText && avoidWrap) {
        avoidText.textContent = d.whyAvoid || '';
        avoidWrap.style.display = d.whyAvoid ? '' : 'none';
      }

      if (usedinList && usedinWrap && usedinMore) {
        usedinList.innerHTML = '';
        var raw = d.usedIn || '';
        if (raw) {
          var entries = raw.split('||U||').filter(function (e) { return e; });
          entries.forEach(function (entry, idx) {
            var pieces = entry.split('@@@');
            var title = pieces[0] || '';
            var url = pieces[1] || '#';
            var a = document.createElement('a');
            a.href = url;
            a.textContent = title;
            a.className = 'aalis-ingredient-modal__usedin-pill';
            if (idx >= USEDIN_CAP) a.hidden = true;
            usedinList.appendChild(a);
          });
          var remaining = entries.length - USEDIN_CAP;
          if (remaining > 0) {
            usedinMore.textContent = '+ ' + remaining + ' ακόμη';
            usedinMore.style.display = '';
          } else {
            usedinMore.style.display = 'none';
          }
          usedinWrap.style.display = '';
        } else {
          usedinWrap.style.display = 'none';
        }
      }

      if (sourceLink) {
        if (d.source) {
          sourceLink.href = d.source;
          sourceLink.style.display = '';
        } else {
          sourceLink.style.display = 'none';
        }
      }

      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () {
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
      }, 200);
    }

    document.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-ingredient-chip]');
      if (chip) {
        openModalFromChip(chip);
        return;
      }
      if (e.target.closest('[data-ingredient-modal-close]')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
